import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { UrlService } from '../url.service';
import { environment } from "src/environments/environment";
import { LocalStorageService } from '../local-storage/local-storage.service';
import { PersistenciaRequest } from 'src/app/entities/shared/persistencia-movimientos/PersistenciaRequest';
import { objBodyPersistenciaDatos } from 'src/app/entities/shared/persistencia-movimientos/PersistenciaRequest';

@Injectable({
  providedIn: 'root'
})

export class PersistenciaService {

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
    private localStorageService: LocalStorageService,
  ) { }

  saveDataLog(persistenciaRequest: PersistenciaRequest, matchKeySelected?) {
    const username: string = this.localStorageService.dataLogin?.getUser();
    const comentarios: string = this.localStorageService.comment;

    //todo: Validar esto ya que la matchkey que se deberia guardar
    // deberia ser la parcial que se obtiene en el metodo de delete

    // Extraer el valor del matchkey
    let matchkey: string;
    if (matchKeySelected) {
      // Si es un array, extraer el valor del primer elemento
      matchkey = Array.isArray(matchKeySelected) && matchKeySelected.length > 0
        ? matchKeySelected[0].value
        : matchKeySelected;
    } else {
      // Si no existe, usar el valor del localStorage
      matchkey = this.localStorageService.getMatchkeySelected;
    }

    console.log("saveDataLogs ----->", comentarios);
    console.log("matchkey ------->", matchkey);

    let objBodyConsumerArKl = objBodyPersistenciaDatos(persistenciaRequest.document,
      persistenciaRequest.entityKey, persistenciaRequest.name, persistenciaRequest.domain,
      persistenciaRequest.subdomain, persistenciaRequest.matriz, username,
      persistenciaRequest.fields, persistenciaRequest.operation, persistenciaRequest.requestId,
      persistenciaRequest.criterios, comentarios, matchkey);

    let msGCPInt = "/".concat(this.localStorageService.configInit["F_URL_MS_IM_GCP"]);
    let msGCPVip = "/gcp-service";
    let rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? (!this.localStorageService.getIsVip ? msGCPInt : msGCPVip)
      : "";
    const backendUrl = this.urlService.getURL(rutaMicroservicio);

    const logURL = "log/" + persistenciaRequest.country;
    const endpoint = `/v1/${logURL}`;

    const headers = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${backendUrl}${endpoint}`, JSON.stringify(objBodyConsumerArKl), { headers: headers })
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  getModifiedFields(dataAntesMod: any, dataADespuesMod: any) {
    let estructura_files: any = {};
    Object.keys(dataAntesMod).forEach(key => {
      if ((dataADespuesMod.value).hasOwnProperty(key)) {
        const valorAntes = String(dataAntesMod[key]);
        const valorDespues = String(dataADespuesMod.value[key]);
        if (valorAntes !== valorDespues) {
          const excludedKeys = [
            "keying",
            "personAddresses",
            "personPhones",
            "businessPhones",
            "businessAddresses",
            "law_detail",
            "employeeAdresses",
            "employeePhones",
            "affiliatePeriodColumn",
          ];
          if (!excludedKeys.includes(key)) {
            estructura_files[key] = { "after": dataADespuesMod.value[key], 'before': dataAntesMod[key] };
          }
        }
      }
    })
    return estructura_files;
  }

  fieldsModifiedManual(dataAntesMod: any, dataADespuesMod: any) {
    let estructura_files: any = {};

    for (let i = 0; i < dataAntesMod.length; i++) {
      let key = dataAntesMod[i].fieldToChange
      estructura_files[key] = { "after": dataAntesMod[i].newValue, 'before': dataADespuesMod[key] };
    }

    return estructura_files;
  }

  // esto debiera se sólo return this.localStorageService.getPersonaSelectedDni; revisar // 2025-05-19
  getvalidaDocumentoPersona(region: string) {
    const personaSelected: any = this.localStorageService.getPersonaSelected || {};
    const regionUpper = (region || '').toUpperCase();

    let numDocumento = this.localStorageService.getPersonaSelectedDni;

    if (numDocumento === undefined || numDocumento === null) {
      numDocumento = personaSelected?.documento;
    }

    if (numDocumento === undefined || numDocumento === null) {
      numDocumento = personaSelected?.documento_numero;
    }

    if (regionUpper === "CL") {
      numDocumento = personaSelected?.cedula ?? numDocumento;
    }

    if (regionUpper === "RD") {
      numDocumento = personaSelected?.nationalId ?? numDocumento;
    }

    if (this.localStorageService.esAltaEntidades) {
      numDocumento = this.localStorageService.getPersonaSelectedDni ?? numDocumento;
    }

    if (numDocumento === undefined || numDocumento === null) {
      numDocumento = personaSelected?.dniDoc;
    }

    if (numDocumento === undefined || numDocumento === null) {
      numDocumento = this.localStorageService.dataFuenteBackup?.documento;
    }

    return numDocumento ?? '';
  }

}
